(() => {
  if (window.TexanBuyingConfidence) return;
  const settings = document.querySelector('[data-tx-confidence-text]');
  let text = {};
  try { text = JSON.parse(settings?.textContent || '{}'); } catch {}
  const storageKey = 'txFittingComparisonV1';
  const showrooms = ['Magnolia', 'Huntsville', 'Montgomery', 'New Caney'];
  let comparison = null;
  const getStored = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      return value?.version === 1 && Array.isArray(value.items) && value.items.length <= 3 && Date.now() - value.createdAt < 86400000 ? value : null;
    } catch { return null; }
  };
  const save = value => {
    if (!value?.items?.length) return;
    try { sessionStorage.setItem(storageKey, JSON.stringify({ ...value, version: 1, createdAt: Date.now() })); } catch {}
  };
  const clear = () => { try { sessionStorage.removeItem(storageKey); } catch {} };
  const showroomPreference = () => {
    try {
      const key = localStorage.getItem('txPreferredShowroom') || '';
      return showrooms.find(item => item.toLowerCase().replace(/ /g, '-') === key.toLowerCase().replace(/ /g, '-')) || '';
    } catch { return ''; }
  };
  const summary = value => value.items.map(item => [
    item.title,
    text.configuration + ': ' + item.configuration,
    text.quantity + ': ' + item.quantity,
    new URL(item.url, location.origin).href
  ].join('\n')).join('\n\n');
  const fittingUrl = (value, showroom = '') => {
    const root = value.root || '/';
    const url = new URL(root.replace(/\/?$/, '/') + 'pages/book-mattress-fitting', location.origin);
    url.searchParams.set('compare', value.items.map(item => item.handle).join(','));
    if (value.size) url.searchParams.set('size', value.size);
    value.items.forEach((item, index) => { if (item.variantId) url.searchParams.set('v' + (index + 1), String(item.variantId)); });
    if (showrooms.includes(showroom)) url.searchParams.set('showroom', showroom);
    url.hash = 'tx-fitting-form';
    return url.href;
  };
  const api = { text, save, clear, summary, fittingUrl, showroomPreference, setComparison(value) { comparison = value; }, getComparison() { return comparison; } };
  window.TexanBuyingConfidence = api;
  function productSelection(root = document.querySelector('[data-tx-confidence]')) {
    if (!root) return null;
    const info = root.closest('.t4s-product__info-container') || root.parentElement;
    const form = info?.querySelector('form[data-type="add-to-cart-form"]');
    const dataNode = info?.querySelector('[data-tx-purchase-data]') || root.closest('[data-product-featured]')?.querySelector('[data-tx-purchase-data]');
    let data;
    try { data = JSON.parse(dataNode?.textContent || '{}'); } catch { return null; }
    const id = form?.querySelector('[name="id"]')?.value;
    const variant = data.variants?.find(item => String(item.id) === String(id));
    if (!variant) return null;
    const S = window.TexanShopping;
    const index = data.options.findIndex(name => /size|dimension/i.test(name));
    const size = index >= 0 ? S?.size(variant.options[index]) || variant.options[index] : '';
    return { version: 1, createdAt: Date.now(), root: root.dataset.root || '/', size, sourceUrl: location.href, items: [{
      handle: root.dataset.handle,
      title: root.dataset.title,
      variantId: variant.id,
      configuration: variant.title,
      quantity: 1,
      url: root.dataset.url + '?variant=' + variant.id
    }], data, variant };
  }
  api.productSelection = productSelection;
  function initProduct(root) {
    if (root.dataset.confidenceReady) return;
    root.dataset.confidenceReady = 'true';
    const form = root.closest('.t4s-product__info-container')?.querySelector('form[data-type="add-to-cart-form"]');
    const details = root.querySelector('[data-tx-fit-alternatives]');
    let queued = false;
    async function updateAlternatives() {
      const payload = productSelection(root);
      const S = window.TexanShopping;
      if (!payload || !S) return;
      const token = String(payload.variant.id);
      root.dataset.alternativeVariant = token;
      const links = [...root.querySelectorAll('[data-tx-alternative]')];
      const configured = [];
      await Promise.allSettled(links.map(async (link, index) => {
        const product = await S.load(payload.root, link.dataset.txAlternative);
        if (root.dataset.alternativeVariant !== token) return;
        const list = S.candidates(product, payload.size, true);
        const variant = S.choose(list.variants);
        link.href = S.link(product, variant);
        configured[index] = { product, variant };
      }));
      if (root.dataset.alternativeVariant !== token) return;
      const url = new URL(payload.root + 'pages/mattress-comparisons', location.origin);
      url.searchParams.set('compare', [payload.items[0].handle, ...links.map(link => link.dataset.txAlternative)].join(','));
      if (payload.size) url.searchParams.set('size', payload.size);
      url.searchParams.set('v1', String(payload.variant.id));
      configured.forEach((item, index) => { if (item?.variant) url.searchParams.set('v' + (index + 2), String(item.variant.id)); });
      const compare = root.querySelector('[data-tx-compare-alternatives]');
      if (compare) compare.href = url.href;
    }
    function update() {
      queued = false;
      const payload = productSelection(root);
      if (!payload) return;
      const url = new URL(root.querySelector('[data-tx-compare-alternatives]').href, location.origin);
      if (payload.size) url.searchParams.set('size', payload.size);
      url.searchParams.set('v1', String(payload.variant.id));
      root.querySelector('[data-tx-compare-alternatives]').href = url.href;
      if (details.open) updateAlternatives();
    }
    const queue = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    details.addEventListener('toggle', () => { if (details.open) updateAlternatives(); });
    form?.addEventListener('change', queue);
    if (form) new MutationObserver(queue).observe(form, { attributes: true, subtree: true, attributeFilter: ['value', 'selected', 'class'] });
    update();
    root.querySelector('[data-tx-open-research]')?.addEventListener('click', event => {
      const suite = document.querySelector('[data-tx-conversion-suite]');
      const trigger = suite?.querySelector('[data-tx-question-open]');
      if (!trigger) { location.href = '/pages/contact-us'; return; }
      const parent = suite.closest('details');
      if (parent) parent.open = true;
      suite.dataset.researchReturnFocus = 'confidence';
      api.returnFocus = event.currentTarget;
      trigger.click();
    });
  }
  function researchMessage(root) {
    const get = key => (root.querySelector('[data-tx-' + key + ']')?.value || '').trim();
    const payload = productSelection() || comparison;
    const message = [text.subject];
    if (payload?.items?.length) message.push('', text.research_context, summary(payload));
    for (const [key, label] of [['question-text','question'],['research-models','models'],['research-link','link'],['research-findings','findings']]) {
      const value = get(key);
      if (value) message.push('', text[label] + ':', value);
    }
    message.push('', text.source + ': ' + location.href);
    return message.join('\n');
  }
  function initResearch(root) {
    if (root.dataset.researchReady) return;
    root.dataset.researchReady = 'true';
    root.addEventListener('click', event => {
      const action = event.target.closest('[data-tx-research-send]');
      if (!action) return;
      const inputs = [...root.querySelectorAll('input,textarea')];
      const link = root.querySelector('[data-tx-research-link]');
      if (link?.value.trim()) {
        let valid = false;
        try { valid = /^https?:$/.test(new URL(link.value.trim()).protocol); } catch {}
        link.setCustomValidity(valid ? '' : text.invalid_link);
        if (!valid) { event.preventDefault(); link.reportValidity(); return; }
      }
      if (!inputs.some(input => input.value.trim())) {
        event.preventDefault();
        const input = root.querySelector('[data-tx-question-text]');
        input?.setCustomValidity(text.missing_question);
        input?.reportValidity();
        return;
      }
      event.preventDefault();
      const message = researchMessage(root);
      location.href = action.dataset.txResearchSend === 'sms'
        ? 'sms:+18326286375?&body=' + encodeURIComponent(message)
        : 'mailto:sales@texanmattress.com?subject=' + encodeURIComponent(text.subject) + '&body=' + encodeURIComponent(message);
    });
    root.addEventListener('input', event => { if (event.target.setCustomValidity) event.target.setCustomValidity(''); });
    const dialog = root.closest('[data-tx-question-dialog]');
    if (dialog) {
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab' || dialog.hidden) return;
        const focusable = [...dialog.querySelectorAll('button,a[href],input,textarea,select')].filter(node => !node.disabled && !node.hidden);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      });
      new MutationObserver(() => { if (dialog.hidden && api.returnFocus) { api.returnFocus.focus(); api.returnFocus = null; } }).observe(dialog, { attributes: true, attributeFilter: ['hidden'] });
    }
  }
  async function initFitting() {
    const section = document.querySelector('[data-tx-fitting-comparison]');
    const form = document.querySelector('#tx-fitting-form');
    if (!section || !form || section.dataset.fittingReady) return;
    section.dataset.fittingReady = 'true';
    form.prepend(section);
    const params = new URLSearchParams(location.search);
    const requested = (params.get('compare') || params.get('product') || '').split(',').filter(handle => handle.length <= 200 && !/[\s/?#\\]/.test(handle)).slice(0,3);
    const S = window.TexanShopping;
    let payload = getStored();
    const explicit = requested.length > 0;
    const matches = payload && requested.every((handle,index) => payload.items[index]?.handle === handle && (!params.get('v' + (index + 1)) || String(payload.items[index].variantId) === params.get('v' + (index + 1)))) && requested.length === payload.items.length && (!params.get('size') || params.get('size') === payload.size);
    if (explicit && !matches) {
      payload = null;
      if (S) {
        const values = await Promise.allSettled(requested.map(async (handle,index) => {
          const product = await S.load('/', handle);
          const wanted = params.get('v' + (index + 1)) || (requested.length === 1 ? params.get('variant') : '');
          const selectedSize = S.size(params.get('size'));
          const list = selectedSize ? S.candidates(product, selectedSize, true) : { variants: product.variants, quantity: 1 };
          const variant = wanted ? list.variants.find(item => String(item.id) === wanted) : S.choose(list.variants);
          if (!variant) throw new Error('Requested configuration unavailable');
          return { handle: product.handle, title: product.title, variantId: variant.id, configuration: variant.title, quantity: list.quantity, url: S.link(product, variant) };
        }));
        if (values.every(value => value.status === 'fulfilled')) payload = { version:1, createdAt:Date.now(), root:'/', size:params.get('size') || '', sourceUrl:location.href, items:values.map(value => value.value) };
      }
    }
    if (!payload?.items?.length) {
      if (explicit) { section.hidden = false; section.querySelector('[data-tx-fitting-items]').textContent = text.load_error; }
      return;
    }
    const hidden = document.createElement('textarea');
    hidden.hidden = true;
    hidden.name = 'contact[Mattress comparison]';
    hidden.value = summary(payload) + '\n\n' + text.display_confirmation;
    form.appendChild(hidden);
    const list = section.querySelector('[data-tx-fitting-items]');
    payload.items.forEach(item => {
      const article = document.createElement('article');
      const title = document.createElement('strong'); title.textContent = item.title;
      const configuration = document.createElement('span'); configuration.textContent = item.configuration;
      const quantity = document.createElement('span'); quantity.textContent = text.quantity + ': ' + item.quantity;
      article.append(title,configuration,quantity); list.appendChild(article);
    });
    section.hidden = false;
    const preferred = params.get('showroom') || showroomPreference();
    const showroom = form.querySelector('#tx-fit-store');
    if (showroom && !showroom.value && showrooms.includes(preferred)) showroom.value = preferred;
    let included = true;
    form.addEventListener('submit', () => {
      const body = form.querySelector('[data-contact-body]');
      if (included && body) body.value += '\n\n' + text.fitting_summary + '\n' + hidden.value;
    });
    section.querySelector('[data-tx-fitting-clear]').addEventListener('click', () => {
      clear(); included = false; hidden.remove(); list.replaceChildren();
      section.hidden = true;
      const url = new URL(location.href);
      for (const key of ['compare','product','size','variant','v1','v2','v3']) url.searchParams.delete(key);
      history.replaceState(null,'',url);
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    let url;
    try { url = new URL(link.href,location.origin); } catch { return; }
    if (url.origin !== location.origin || !url.pathname.endsWith('/pages/book-mattress-fitting')) return;
    const payload = productSelection() || comparison;
    if (!payload?.items?.length) return;
    const clean = { version:1, createdAt:Date.now(), root:payload.root || '/', size:payload.size, sourceUrl:payload.sourceUrl, items:payload.items };
    save(clean);
    link.href = fittingUrl(clean,url.searchParams.get('showroom') || showroomPreference());
  },true);
  function boot() {
    document.querySelectorAll('[data-tx-confidence]').forEach(initProduct);
    document.querySelectorAll('[data-tx-research-card]').forEach(initResearch);
    initFitting();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
